import api from '@/API';
import _ from 'lodash';
import { ReportPost } from '@/type';
import eventBus from '@/messaging/event-bus';
import { ReportPostCommentEdited } from '@/messaging/events';

export function edit(id: number, comment: string|null): Promise<void> {
  const url = `report-posts/${id}`;
  return api
    .put(url, { comment })
    .then(() => {
      eventBus.$emit(ReportPostCommentEdited.eventName, new ReportPostCommentEdited());
    });
}

export function trash(reportPost: ReportPost): Promise<ReportPost> {
  return api
    .delete(`report-posts/${reportPost.id}`)
    .then(() => {
      const copy = _.cloneDeep(reportPost);
      copy.isTrashed = true;
      return copy;
    });
}

export function restore(reportPost: ReportPost): Promise<ReportPost> {
  return api
    .put(`report-posts/${reportPost.id}/restore`)
    .then(() => {
      const copy = _.cloneDeep(reportPost);
      copy.isTrashed = false;
      return copy;
    });
}
